import { entitiesApi, useSelector, useThunkDispatch } from '@tunasong/redux'
import { useEffect } from 'react'

function isAccessRequestAlert(alert: unknown): alert is { type: 'access-request'; entity?: { id?: string } } {
  return Boolean(alert && typeof alert === 'object' && (alert as { type?: unknown }).type === 'access-request')
}

/**
 * A request arriving while a list is open (WebSocket `setNotification`) inserts its row without a reload. Focus is
 * not moved (request-access spec §7.3, §8.5).
 */
export const useRefreshOnAccessRequestNotification = () => {
  const dispatch = useThunkDispatch()
  const alert = useSelector(state => state.notifications.alert)
  const arrived = isAccessRequestAlert(alert)
  const entityId = arrived ? alert.entity?.id : undefined

  useEffect(() => {
    if (!arrived) {
      return
    }
    dispatch(
      entitiesApi.util.invalidateTags([
        { type: 'AccessRequests', id: 'owner' },
        ...(entityId ? [{ type: 'AccessRequests' as const, id: entityId }] : []),
      ])
    )
  }, [arrived, entityId, dispatch])
}
